<script lang="ts">
import { Avatar as AvatarPrimitive } from 'bits-ui';

let { ...restProps }: AvatarPrimitive.ImageProps = $props();
</script>

<AvatarPrimitive.Image
  style="height: 100%; width: 100%; object-fit: cover;"
  {...restProps}
/>
